var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "signin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.93,199.73q-16.39-16.41-39.84-16.41H447.87a7,7,0,0,0-7,7v23.44a7,7,0,0,0,7,7h49.22a19,19,0,0,1,18.75,18.75v112.5a19,19,0,0,1-18.75,18.75H447.87a7,7,0,0,0-7,7v23.44a7,7,0,0,0,7,7h49.22q23.45,0,39.84-16.41t16.41-39.84V239.57Q553.34,216.13,536.93,199.73Zm-67.38,90.82-98.44-98.44a14.06,14.06,0,0,0-24,10v56.25H267.4a14,14,0,0,0-14.06,14.06v56.25a14,14,0,0,0,14.06,14.06h79.69v56.25a14.09,14.09,0,0,0,24,10l98.44-98.44a14.15,14.15,0,0,0,0-19.92Z",
    fill: "#3fa9f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.7ffc4157109946d21fe0679036031cf4.svg";
export { ForwardRef as ReactComponent };